import React from 'react';
import { useTheme } from '@hooks/use-theme';

export default function Image({ src = null, light = null, dark = null, ...props }) {
  const [theme] = useTheme();
  let source = src || dark || light;

  if (theme === 'light' && light) {
    source = light;
  } else if (theme !== 'light' && dark) {
    source = dark;
  }

  return <img src={source} {...props} />;
}
